import { render, staticRenderFns } from "./AvgInventoryPiecesProcessedByHour.vue?vue&type=template&id=347e3b95&scoped=true&"
import script from "./AvgInventoryPiecesProcessedByHour.vue?vue&type=script&lang=js&"
export * from "./AvgInventoryPiecesProcessedByHour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e3b95",
  null
  
)

export default component.exports